import React from "react";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import Card from "reactstrap/lib/Card";
import CardBody from "reactstrap/lib/CardBody";
import { FormattedMessage } from "react-intl";
import SupportContact from "../../components/SupportContact/SupportContact";

// Landningssida för Analytics-tjänstekonton, samma roll som SupervisorHome för
// handledare: den som loggar in i webben med ett sådant konto ska få ett besked,
// inte en tom sida.
function AnalyticsHome() {
  return (
    <Container className="py-4">
      <Row className="justify-content-center">
        <Col md="8" lg="6">
          <Card className="rounded-4">
            <CardBody className="text-center p-4">
              <h3 className="mt-3 mb-3">
                <FormattedMessage id="Views.AnalyticsHome.Title" />
              </h3>
              <p>
                <FormattedMessage id="Views.AnalyticsHome.Intro" />
              </p>
              <hr className="my-4" />
              <SupportContact />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default AnalyticsHome;
